import { Alert, Button } from "reactstrap";
import { PlaylistIndexManipulator } from "../../playlists/PlaylistIndexManipulator";
import PlaylistData from "../data/PlaylistData";
import { useNavigate } from "react-router-dom";
import { RoutePaths } from "../../RoutePaths";
import { PlaylistRoutePaths } from "../PlaylistRoutePaths";
import { Trans, useTranslation } from "react-i18next";

interface Props {
  playlistData: PlaylistData;
}

export function ImportedPlaylistInfo(props: Props) {
  const { t } = useTranslation();

  const navigate = useNavigate();

  function transformIntoOwnPrivatePlaylist() {
    const newIdentifier = PlaylistIndexManipulator.movePlaylistToCrew(
      props.playlistData,
      undefined,
    );
    // add some browser history to be able to use the back buttons as expected
    navigate(RoutePaths.HOME);
    navigate(PlaylistRoutePaths.toCarousel(newIdentifier));
    //we need to reload the page
    navigate(0);
  }

  return (
    <Alert color="secondary" fade={false}>
      <p>
        <b>{t("playlist.importedTitle")}</b>
      </p>
      <p>
        <Trans i18nKey="playlist.importedDesc">
          Diese Playlist wurde durch das Scannen eines QR-Codes importiert.
          Deshalb kannst du sie nicht editieren.
        </Trans>
        und sie wird auch nicht mit deinen anderen Geräten synchronisiert.
        <br />
        Du kannst diese Playlist aber jederzeit in eine eigene, private Playlist
        umwandeln.
      </p>
      <Button
        color="link"
        onClick={() => transformIntoOwnPrivatePlaylist()}
        className="p-0 m-0"
      >
        Jetzt umwandeln
      </Button>
    </Alert>
  );
}
